export default __webpack_public_path__ + "static/media/todo.17d70fee.PNG";